import React, { useState } from "react"
import { Button, Grid, Modal } from "semantic-ui-react"
import { useStore } from "store"

const TermsofUse = () => {
  const [isModalOpen, toggleModalOpen] = useState(false)
  const [terms] = useStore("termsAndConditions")
  return (
    <span>
      <span style={{ cursor: "pointer" }} onClick={() => toggleModalOpen(true)}>
        Terms of Use
      </span>

      {isModalOpen ? (
        <Modal
          defaultOpen={true}
          style={{ minHeight: "20em" }}
          onClose={() => toggleModalOpen(false)}
          closeOnDimmerClick={false}
          className="scrolling"
          onMount={() => {
            setTimeout(() => {
              ;["dimmable", "dimmed", "scrolling"].forEach(className => {
                document
                  .getElementsByTagName("body")[0]
                  .classList.add(className)
              })
            }, 0)
          }}
          onUnmount={() => {
            ;["dimmable", "dimmed", "scrolling"].forEach(className => {
              document
                .getElementsByTagName("body")[0]
                .classList.remove(className)
            })
          }}
        >
          <Modal.Content>
            <Grid className="white">
              <Grid.Row>
                <Grid.Column className="Agreement">
                  <h1 className="title">Terms of Use</h1>
                  <div dangerouslySetInnerHTML={{ __html: terms }} />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row style={{ borderTop: "1px solid #ccc" }}>
                <Grid.Column textAlign="right" style={{ paddingRight: "2em" }}>
                  <Button
                    onClick={() => toggleModalOpen(false)}
                    content="Ok"
                    primary
                    type="button"
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Content>
        </Modal>
      ) : null}
    </span>
  )
}

export default TermsofUse
